import {Observable} from 'rxjs';
import {jobHunterAPI} from './provider/jobHunterAPI';
import {RestQueryParams} from './base/queryParams';

export function clearChatNotification(accessToken: string, notificationId): Observable<any> {
    return jobHunterAPI.delete(`notifications/${notificationId}`, new RestQueryParams(), {
        Authorization: `Bearer ${accessToken}`,
    });
}
